import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取权限树数据
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getPrivilegeList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/query.privilegeGroup.noAddPrivilege',
      method: 'get',
      params: {
        ...params
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加权限到角色组
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function addPrivilegeToGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/add.privilege.PrivilegeGroup',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 从角色组移除权限
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function deletePrivilegeFromGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/delete.privilege.PrivilegeGroup',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取未分配的权限
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getNoGroupPrivileges(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilege.queryNoGroupPrivileges',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}